import { get, put } from "./base.js";

const SettingsServ = {
    get: (key) => {
        return get(`/settings/${key}`);
    },

    update: (key, payload) => {
        return put(`/settings/${key}`, payload);
    }
};

export default SettingsServ;
